<ng-container *ngIf="group && field">

    <div class="main-outer-container " [formGroup]="group" [hidden]="field.hidden || false">
  
      <div class="flex flex-col align-top my-2">
        <label for="{{field!.name}}" [hidden]="field!.hidden ? field!.hidden: false"
          class="label col-sm-3 col-form-label">{{field.label}}</label>
  
        <input #inputEl [id]="field.name" [readonly]="field.readonly || false" 
          [hidden]="field.hidden ||  false" [formControlName]="field.name" [ngClass]="field!.cssClass + ' e-input transform duration-300'"
          [placeholder]="field.placeholder || ''"  [value]="field.value || ''"
          [required]="field.isRequired ?? false" 
          (change)="onChangeValue($event)" (focus)="onFocus($event)"
          [type]="format" 
                      >
        </div>

        
        <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
        <div class="flex align-top flex-col gap-2"
      *ngIf="group.controls[field.name]?.dirty || group.controls[field.name]?.touched">
      <ng-container *ngFor="let validation of field!.validations;let i= index;">
        <!--<span *ngIf="group!.controls[field!.name].hasError(validation.name)"
              style="color: red;">{{validation.message}}&nbsp;&nbsp;</span>-->

        <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
          class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>

          <p>{{validation.message}}</p>
        </div>
      </ng-container>

    </div>
      </div>
  </ng-container>

  <ng-container *ngIf="!group">    
    <div class="flex">
      <input #datePicker style="border-radius: 10px 0px 0px 10px !important;" [id]="parsedFieldId" [type]="parsedDateFormat" [class]="'e-input  transform duration-300'" [(ngModel)]="dateValue" (keyup)="pushValue($event)" (change)="pushValue($event)" (focus)="onFocus($event)" >
      <button  class="clear-date-btn" (click)="clearDate($event)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>        
      </button>
    </div>
      
  </ng-container>
  